<!--
/**
* @name: Add.vue
* @description: 添加用户
* @author: 于海威
* @create: 2020/08/07 17:59:54
* @update: 2020/08/07 17:59:54
*/
-->

<template>
  <y-view :title="isView ? '查看用户' : isEdit ? '编辑用户' : '新建用户'" :loading="isLoading">
    <template v-if="isView">
      <y-form titleAlign="left" titleWidth="100px" contentWidth="400px">
        <y-form-item title="用户账号:">
          <insensitive :val="editPara.username" type="phone"></insensitive>
        </y-form-item>
        <y-form-item title="用户姓名:">
          <insensitive :val="editPara.name" type="name"></insensitive>
        </y-form-item>
        <y-form-item title="推广公司:">
          <span>{{ editPara.companyCode | filterCompany(this.companyList) }}</span>
        </y-form-item>
        <y-form-item title="组织机构:">
          <span>{{ editPara.orgName }}</span>
        </y-form-item>
        <y-form-item title="销售渠道:">
          <span>{{ editPara.saleChannelCodes | filterChannel(this.distributionChannelList) }}</span>
        </y-form-item>
        <y-form-item title="职位:">
          <span>{{ editPara.position }}</span>
        </y-form-item>
        <y-form-item title="所在部门:">
          <span>{{ editPara.department }}</span>
        </y-form-item>
        <y-form-item title="角色配置:">
          <span>{{ editPara.roleIdList | filterRole(this.roleList) }}</span>
        </y-form-item>
        <y-form-item title="备注:" align="top">
          <span>{{ editPara.remark }}</span>
        </y-form-item>
      </y-form>
    </template>
    <template v-else>
      <y-form titleAlign="left" titleWidth="100px" contentWidth="400px">
        <y-form-item title="用户ID:" required>
          <k-input placeholder="创建后自动生成" v-model="editPara.id" block disabled></k-input>
        </y-form-item>
        <y-form-item title="用户姓名:" required>
          <k-input placeholder="请输入用户姓名" v-model="editPara.name" v-validate="'required|minLength(2)|maxLength(20)'" block maxlength="20"></k-input>
        </y-form-item>
        <y-form-item title="用户密码:" required v-if="!isEdit">
          <k-input
            placeholder="请设置由英文+数字组成的8-10位字符"
            v-model="editPara.password"
            v-validate="'minLength(8)|maxLength(10)|regex(/^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/)'"
            block
          ></k-input>
        </y-form-item>
        <y-form-item title="用户账号:" required>
          <k-input placeholder="请输入手机号码" :disabled="isEdit ? true : false" maxlength="11" v-model="editPara.username" v-validate="'phone'" block></k-input>
        </y-form-item>
        <y-form-item title="推广公司:">
          <k-select placeholder="请选择推广公司" :disabled="isSub ? true : false" block v-model="editPara.companyCode">
            <k-option v-for="item in companyList" :selected="editPara.companyCode == item.code" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
          </k-select>
        </y-form-item>
        <y-form-item title="组织机构:">
          <k-select placeholder="请选择组织机构" :disabled="isSub ? true : false" block v-model="editPara.orgCode">
            <k-option v-for="item in organizationList" :selected="editPara.orgCode == item.ocode" :key="item.ocode" :value="item.ocode" :label="item.oname">{{ item.oname }}</k-option>
          </k-select>
        </y-form-item>
        <y-form-item title="销售渠道:" required v-if="!isSub">
          <k-select2
            placeholder="请选择销售渠道"
            search-field="name"
            text-field="name"
            key-field="code"
            block
            layerMinWidthEqual
            :data="distributionChannelList"
            v-model="editPara.saleChannelCodes"
          ></k-select2>
        </y-form-item>
        <y-form-item title="销售渠道:" required v-else>
          <span>{{ editPara.saleChannelCodes | filterChannel(this.distributionChannelList) }}</span>
        </y-form-item>
        <y-form-item title="职位:">
          <k-input placeholder="请输入职位名称" v-model="editPara.position" block></k-input>
        </y-form-item>
        <y-form-item title="所在部门:">
          <k-input placeholder="请输入所在部门名称" v-model="editPara.department" block></k-input>
        </y-form-item>
        <y-form-item title="角色配置:" required>
          <k-select2 :data="roleList" v-model="editPara.roleIdList" search-field="name" text-field="name" key-field="id" placeholder="请选择角色" block layerMinWidthEqual></k-select2>
        </y-form-item>
        <y-form-item title="备注:" align="top">
          <k-input tag="textarea" v-model="editPara.remark" block placeholder="请输入备注信息"></k-input>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_ORG_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DETAIL,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_SAVE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
} from "@/assets/modules/apiList";

const initPara = () => ({
  department: "",
  name: "",
  orgCode: "",
  orgName: "",
  orgShortName: "",
  password: "",
  companyCode: "",
  position: "",
  remark: "",
  roleIdList: [],
  saleChannelCodes: "",
  username: "",
});
export default {
  data() {
    return {
      id: "",
      editPara: initPara(),
      isEdit: false,
      isView: false,
      isLoading: false,
      isSaving: false,
      organizationList: [], // 组织机构
      distributionChannelList: [], // 销售渠道
      roleList: [], // 角色列表
      companyList: [],
      originData: {},
      isSub: false, //是否是子公司
    };
  },
  watch: {
    "editPara.orgCode"(v) {
      if (v) {
        let orgList = this.organizationList;
        for (let i = 0; i < orgList.length; i++) {
          if (orgList[i].ocode == v) {
            this.editPara.orgName = orgList[i].oname;
            this.editPara.orgShortName = orgList[i].shortName;
            break;
          }
        }
      }
    },
    "editPara.roleIdList"(v) {},
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        let username = para.username.toString().replace(/\s*/g, "");
        if (
          name.length < 2 ||
          name.length > 20 ||
          !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(username) ||
          (!this.isEdit && !/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,10}/.test(para.password)) ||
          !para.saleChannelCodes ||
          !para.roleIdList.length
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  methods: {
    getUser(username) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DETAIL,
        para: { username },
      })
        .then((res) => {
          if (res.systemRoleVOList && res.systemRoleVOList.length) {
            let tmpArr = [];
            res.systemRoleVOList.forEach((s) => {
              tmpArr.push(s.id);
            });
            res.roleIdList = tmpArr;
          } else {
            res.roleIdList = [];
          }
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getOrganizationList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_ORG_LIST,
        para: {},
      }).then((res) => {
        this.organizationList = res;
      });
    },
    getCompanyList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {},
      }).then((res) => {
        this.companyList = res || [];
      });
    },
    getDistributionChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.distributionChannelList = res || [];
      });
    },
    getRoleList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_LIST,
        para: {
          isEnabled: true,
        },
      }).then((res) => {
        this.roleList = res || [];
      });
    },
    onSave() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE : NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "userManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
  },
  filters: {
    filterChannel(code, arr) {
      console.log(code);
      let tmp = [];
      arr.forEach((a) => {
        if (code.indexOf(a.code) > -1) {
          tmp.push(a.name);
        }
      });
      return tmp.join("，");
    },
    filterCompany(code, arr) {
      let tmp = "";
      arr.forEach((a) => {
        if (code == a.code) {
          tmp = a.name;
        }
      });
      return tmp;
    },
    filterRole(code, arr) {
      console.log(code);
      let tmp = [];
      arr.forEach((a) => {
        if (code.join(",").indexOf(a.id) > -1) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
  },
  async created() {
    this.getOrganizationList();
    this.getDistributionChannelList();
    this.getRoleList();
    this.getCompanyList();
    const { username, view, edit } = this.$route.query;
    const lastLogin = await this.$lf.getItem("login");
    if (lastLogin.roleType == "SUB") {
      this.isSub = true;
    }
    if (username) {
      this.getUser(username);
      if (view) {
        this.isView = true;
        this.isEdit = false;
      } else if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const { username, view, edit } = to.query;
    this.editPara = initPara();

    if (username) {
      this.getUser(username);
      if (view) {
        this.isView = true;
        this.isEdit = false;
      } else if (edit) {
        this.isView = false;
        this.isEdit = true;
      } else {
        this.isView = false;
        this.isEdit = false;
      }
    } else {
      this.isView = false;
      this.isEdit = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
